import React, { forwardRef, useMemo } from 'react';
import { path } from 'ramda';
import { Icon } from '../../icon';
import { StyledTextInput } from './styled';
// pattern matching for JS peasants
const fnMAP = (prependInnerIcon) => ({
    true: { prependIconExist: prependInnerIcon, prependIconDoesntExist: React.createElement(Icon, { name: "calendar" }) },
    false: { prependIconExist: undefined, prependIconDoesntExist: undefined },
    undefined: {
        prependIconExist: prependInnerIcon,
        prependIconDoesntExist: React.createElement(Icon, { name: "calendar" })
    }
});
export const DatePickerInput = forwardRef((props, ref) => {
    const { showIcon, prependInnerIcon: prependInnerIconProp, ...rest } = props;
    const prependInnerIcon = useMemo(() => {
        var _a;
        const stringedShowIconVal = (_a = showIcon === null || showIcon === void 0 ? void 0 : showIcon.toString()) !== null && _a !== void 0 ? _a : 'undefined';
        const prependIconState = prependInnerIconProp ? 'prependIconExist' : 'prependIconDoesntExist';
        return path([stringedShowIconVal, prependIconState], fnMAP(prependInnerIconProp));
    }, [showIcon, prependInnerIconProp]);
    return React.createElement(StyledTextInput, { ref: ref, prependInnerIcon: prependInnerIcon, ...rest });
});
